import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PrivateRoute from "./components/PrivateRoute";
import SignInPage from "./pages/SignInPage";
import { useDispatch } from "react-redux";
import { setUser } from "./redux/slices/authSlice";
import { useEffect } from "react";
import ManageCategoryPage from "./pages/ManageCategoryPage";
import UsersListPage from "./pages/UsersListPage";
import BlogListPage from "./pages/BlogListPage";
import AddBlogPage from "./pages/AddBlogPage";
import EditBlogPage from "./pages/EditBlogPage";
import ManageAdminPage from "./pages/ManageAdminPage";
import SiteDetailsPage from "./pages/SiteDetailsPage";
import ContactListPage from "./pages/ContactListPage";
import NewServicemenPage from "./pages/NewServicemenPage";
import ServiceProfilePage from "./pages/ServicemenProfilePage";
import EditServicemenPage from "./pages/EditServicemenPage";
import NotificationPage from "./pages/NotificationPage";
import AdminMessagesPage from "./pages/AdminMessagesPage";
import AllJobsPage from "./pages/AllJobsPage";
import ApplicanListPage from "./pages/ApplicanListPage";
import ServicemenLeadsPage from "./pages/ServicemenLeadsPage";
import AllBookingsPage from "./pages/AllBookingsPage";
import RewardProductListPage from "./pages/RewardProductListPage";
import RedeemProductHistoryListPage from "./pages/RedeemProductHistoryListPage";
import InvoicePage from "./pages/InvoicePage";
import LeaderboardPage from "./pages/LeaderboardPage";
import PlansListPage from "./pages/PlansListPage";
import CreatePlanPage from "./pages/CreatePlanPage";
import EditPlanPage from "./pages/EditPlanPage";
import TransactionsPage from "./pages/TransactionsPage";


function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    const user = localStorage.getItem("user");

    if (user) {
      dispatch(setUser(user));
    }

  }, [dispatch]);



  return (

    <BrowserRouter>

      <RouteScrollToTop />

      <Routes>

        <Route path="/login" element={<SignInPage />} />

        {/* 🔐 Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<HomePageOne />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/servicemen-list" element={<NewServicemenPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/servicemen/:userId" element={<ServiceProfilePage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-bookings/" element={<AllBookingsPage />} />
        </Route>


        <Route element={<PrivateRoute />}>
          <Route path="/edit-servicemen/:userId" element={<EditServicemenPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-categories" element={<ManageCategoryPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-users" element={<UsersListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/manage-admin" element={<ManageAdminPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/create-blog" element={<AddBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-blog/:id" element={<EditBlogPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-blogs" element={<BlogListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/contacts" element={<ContactListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/notifications" element={<NotificationPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/admin-message" element={<AdminMessagesPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/update-site-details" element={<SiteDetailsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/all-jobs" element={<AllJobsPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/applicant-list/:jobId" element={<ApplicanListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/reward-products" element={<RewardProductListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/product-redeem-history" element={<RedeemProductHistoryListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/view-invoice/:orderId" element={<InvoicePage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/leaderboard" element={<LeaderboardPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/create-plan" element={<CreatePlanPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/plans" element={<PlansListPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/edit-plan/:id" element={<EditPlanPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="/transactions" element={<TransactionsPage />} />
        </Route>

        {/* ❌ Fallback */}
        <Route path="*" element={<ErrorPage />} />

      </Routes>

    </BrowserRouter>

  );
}

export default App;
